import styles from './index.module.css'

import React from 'react'

import Alert from 'components/ui/alert'
import Stack from 'components/ui/stack'

type Props = {
  errorMessage?: string
}

const SimilarityAlert = ({
  errorMessage = undefined,
}: Props): null | React.ReactElement<'div'> => {
  if (!errorMessage) return null
  return (
    <div className={styles.similarityAlert}>
      <Stack space="xxsmall">
        <Alert icon="warning" status="danger">
          {errorMessage}
        </Alert>
      </Stack>
    </div>
  )
}

export default SimilarityAlert
